let googleIdentityScriptPromise = null

function resolveGoogleIdentity() {
  return window.google?.accounts?.id ? window.google : null
}

export function loadGoogleIdentityScript() {
  const googleIdentity = resolveGoogleIdentity()
  if (googleIdentity) return Promise.resolve(googleIdentity)
  if (googleIdentityScriptPromise) return googleIdentityScriptPromise

  googleIdentityScriptPromise = new Promise((resolve, reject) => {
    const existingScript = document.querySelector('script[data-google-identity-script="true"]')

    const onLoad = () => {
      const loadedGoogleIdentity = resolveGoogleIdentity()
      if (loadedGoogleIdentity) {
        resolve(loadedGoogleIdentity)
      } else {
        googleIdentityScriptPromise = null
        reject(new Error("Google sign-in did not finish loading."))
      }
    }

    const onError = () => {
      googleIdentityScriptPromise = null
      reject(new Error("Google sign-in could not be loaded."))
    }

    if (existingScript) {
      existingScript.addEventListener("load", onLoad, { once: true })
      existingScript.addEventListener("error", onError, { once: true })
      return
    }

    const script = document.createElement("script")
    script.src = "https://accounts.google.com/gsi/client"
    script.async = true
    script.defer = true
    script.dataset.googleIdentityScript = "true"
    script.addEventListener("load", onLoad, { once: true })
    script.addEventListener("error", onError, { once: true })
    document.head.appendChild(script)
  })

  return googleIdentityScriptPromise
}
